export default "/images/img_10.png?7cc2a0ff470561415c81aa07d46fe1f1";